import { render, staticRenderFns } from "./GroupMessages.vue?vue&type=template&id=0399d808&"
import script from "./GroupMessages.vue?vue&type=script&lang=js&"
export * from "./GroupMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports